import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as tally from './TallyRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({tally: state.tally})
const connector = connect(mapState, tally.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const TallyInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(TallyInit)
